<template>
  <div>
    <div class="overview-tips">
      <!-- 上 有”眼睛”的行 -->
      <div class="tips-top">
        <span>本月已赚</span>
        <div class="tips-top-eye" @click="changeDisplayHandler">
          <svg-icon :icon-class="imgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!-- 中 -->
      <div class="tips-center" @click="$emit('clickCell', hideFlag, 'OverviewTips')">
        <span>{{ dataList.allMoney }}</span>
      </div>
      <!-- 下 -->
      <div class="tips-bottom">
        <!-- 佣金 -->
        <div class="tips-bottom-info" @click="$emit('clickCell', hideFlag, 'OverviewTips')">
          <div>
            <span>{{ dataList.profit }}</span>
          </div>
          <div>
            <span>佣金(元)</span>
          </div>
        </div>
        <!-- 达标奖励 -->
        <div class="tips-bottom-info" @click="$emit('clickCell', hideFlag, 'OverviewTips')">
          <div>
            <span>{{ dataList.reward }}</span>
          </div>
          <div>
            <span>达标奖励(元)</span>
          </div>
        </div>
        <!-- 服务费代收 -->
        <div class="tips-bottom-info" @click="$emit('clickCell', hideFlag, 'OverviewTips')">
          <div>
            <span>{{ dataList.service }}</span>
          </div>
          <div>
            <span>服务费代收(元)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetTradeCount } from '@/api/reward';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import SvgIcon from './SvgIcon';

export default {
  name: 'OverviewTips',
  props: ['flag'],
  comments: { SvgIcon },
  data() {
    return {
      hideFlag: 'hide',
      imgEyePath: 'hide_money',
      dataList: {
        allMoney: '',
        profit: '',
        reward: '',
        service: '',
      },
      dataList_hide: {
        allMoney: '****',
        profit: '****',
        reward: '****',
        service: '****',
      },
      dataList_show: {
        allMoney: '100000.00',
        profit: '12000.00',
        reward: '11100.00',
        service: '99990.00',
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      // 图片/状态置为隐藏
      this.hideFlag = 'hide';
      this.imgEyePath = 'hide_money';
      // 加载数据
      this.dataRebuild(this.dataList_hide);
    });
  },
  methods: {
    getTradeCount(flag, callBack = null) {
      Indicator.open();
      GetTradeCount({ flag })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataRebuild(res.data.profit);
            callBack && callBack();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },

    dataRebuild(data) {
      this.dataList.allMoney = data.allMoney;
      this.dataList.profit = data.profit;
      this.dataList.reward = data.reward;
      this.dataList.service = data.service;
    },

    changeDisplayHandler() {
      if (this.hideFlag === 'hide') {
        switch (this.$store.state.INTERFACE_ON_OFF) {
          case 'on':
            this.getTradeCount(this.flag, () => {
              this.hideFlag = 'show';
              this.imgEyePath = 'show_money';
            });
            break;
          case 'off':
            this.dataRebuild(this.dataList_show);
            this.hideFlag = 'show';
            this.imgEyePath = 'show_money';
            break;
        }
      } else if (this.hideFlag === 'show') {
        this.dataRebuild(this.dataList_hide);
        this.hideFlag = 'hide';
        this.imgEyePath = 'hide_money';
      }
    },
  },
  filters: {
    shortText(val) {
      if (val.length > 12) return val.substring(0, 12) + '…';
      return val;
    },
  },
};
</script>
